import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import Professional from '../../models/Professional'
import VocationalTraningService from "../../services/VocationalTraningService";
import VocationalTraning from "../../models/VocationalTraning";
import OptionItem from "../../models/OptionItem";

export class ReRegistrationVocationalTrainingFormItem {
    Id: number;
    Expertise: string;
    ExpertiseValue: any;
    DateAcquisition: Date | undefined;
    NumberRQE: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;

    constructor(Id: number, Expertise: any, DateAcquisition?: Date, NumberRQE?: string) {
        this.Id = Id;
        this.Expertise = Expertise.Text;
        this.ExpertiseValue = Expertise;
        this.DateAcquisition = DateAcquisition;
        this.NumberRQE = NumberRQE;
    }

    static NewInstance(): ReRegistrationVocationalTrainingFormItem {
        return new ReRegistrationVocationalTrainingFormItem(0, "", undefined, "");
    }

}

export default class ReRegistrationVocationalTrainingForm implements FormBase {

    Expertise: FormFieldBase;
    DateAcquisition: FormFieldBase;
    NumberRQE: FormFieldBase;
    FormItemList: ReRegistrationVocationalTrainingFormItem[];
    FormRemoveList: ReRegistrationVocationalTrainingFormItem[];
    FormItemToEdit: ReRegistrationVocationalTrainingFormItem;

    constructor(Expertise: string, DateAcquisition: string, NumberRQE: string) {

        this.Expertise = new FormFieldBase(Expertise, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.NumberRQE = new FormFieldBase(NumberRQE, []);;
        this.DateAcquisition = new FormFieldBase(DateAcquisition, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("A data de obtenção informada é inválida.", ValidationType.DATA)]);;
        this.FormItemList = new Array<ReRegistrationVocationalTrainingFormItem>();
        this.FormRemoveList = new Array<ReRegistrationVocationalTrainingFormItem>();
        this.FormItemToEdit = ReRegistrationVocationalTrainingFormItem.NewInstance();
    }

    AddOrUpdateReRegistrationVocationalTrainingFormItem() {
        if (this.ValidateForm()) {

            //Insert
            if (this.FormItemToEdit === null || this.FormItemToEdit.Id === 0) {

                let item = new ReRegistrationVocationalTrainingFormItem(
                    this.getNewId(),
                    this.Expertise.Value,
                    this.DateAcquisition.Value,
                    this.NumberRQE.Value,
                )

                this.FormItemList.push(item);

            //Update    
            } else {
                for (let index = 0; index < this.FormItemList.length; index++) {
                    const element = this.FormItemList[index];
                    if (element.Id === this.FormItemToEdit.Id) {

                        let item = new ReRegistrationVocationalTrainingFormItem(
                            element.Id,
                            this.Expertise.Value,
                            this.DateAcquisition.Value,
                            this.NumberRQE.Value,
                        )

                        item.RemoveTasy = element.RemoveTasy;
                        item.TasyCode = element.TasyCode;

                        this.FormItemList[index] = item;
                    }
                }
            }
            this.ResetForm();
        }
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<boolean> {
        if ((this.FormItemList !== null && this.FormItemList.length > 0) || (this.FormRemoveList !== null && this.FormRemoveList.length > 0)) {
            const dataJson = this.getJsonObjet();
            return VocationalTraningService.postInsertOrUpdateVocationalTraning(dataJson, Professional.Id);
        } else {
            return Promise.resolve(true);
        }
    }

    async PreloadFormFromApi(requestId: string): Promise<any> {

        return await VocationalTraningService.CreateAndGetVocationalTraningFromTasy(requestId).then((data: VocationalTraning[]) => {

            this.FormItemList = new Array<ReRegistrationVocationalTrainingFormItem>();
            this.FormRemoveList = new Array<ReRegistrationVocationalTrainingFormItem>();

            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                let optionExpertise: OptionItem | undefined = undefined;

                if (element.ExpertiseId !== undefined && element.ExpertiseValue !== undefined) {
                    optionExpertise = new OptionItem(element.ExpertiseId, element.ExpertiseValue, element.ExpertiseId.toString());
                }
                
                let item = new ReRegistrationVocationalTrainingFormItem(
                    this.getNewId(),
                    optionExpertise,
                    element.DateAcquisition,
                    element.NumberRQE
                )

                item.RemoveTasy = element.RemoveTasy;
                item.TasyCode = element.TasyCode;

                this.FormItemList.push(item);

            }

        });
    }

    EditReRegistrationVocationalTrainingFormItem(id: number) {
        this.ResetForm();

        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];

            if (element.Id === id) {
                this.FormItemToEdit = element;
                this.Expertise.Value = this.FormItemToEdit.ExpertiseValue;
                this.DateAcquisition.Value = this.FormItemToEdit.DateAcquisition;
                this.NumberRQE.Value = this.FormItemToEdit.NumberRQE;
            }
        }
    }

    RemoveReRegistrationVocationalTrainingFormItem(id: number) {
        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];
            if (element.Id === id) {
                if(element.TasyCode === undefined || element.TasyCode === 0) {
                    this.FormItemList.splice(index, 1);
                }else{
                    element.RemoveTasy = true;
                    this.FormRemoveList.push(element);
                    this.FormItemList.splice(index, 1);
                }
            }
        }
    }


    static NewInstance(): ReRegistrationVocationalTrainingForm {
        return new ReRegistrationVocationalTrainingForm("", "", "");
    }

    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }


    ValidateToGoNextStep(): string {
        if (this.FormItemList.length === 0) {
            return "Por favor, insira ao menos uma formação profissional."
        }
        return "";
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }

        this.FormItemToEdit = ReRegistrationVocationalTrainingFormItem.NewInstance();
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Expertise":
                return this.Expertise;
            case "DateAcquisition":
                return this.DateAcquisition
            case "NumberRQE":
                return this.NumberRQE

            default:
                return new FormFieldBase("", []);
        }
    }


    getNewId(): number {
        if (this.FormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.FormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }


    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        if (this.FormItemList !== null && this.FormItemList.length > 0) {
            this.FormItemList.forEach((element: ReRegistrationVocationalTrainingFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "expertiseId": element.ExpertiseValue.Id,
                    "dateAcquisition": element.DateAcquisition,
                    "nrRQE": element.NumberRQE,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        if (this.FormRemoveList !== null && this.FormRemoveList.length > 0) {
            this.FormRemoveList.forEach((element: ReRegistrationVocationalTrainingFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "expertiseId": element.ExpertiseValue.Id,
                    "dateAcquisition": element.DateAcquisition,
                    "nrRQE": element.NumberRQE,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        return viewModelList;
    }
}